import { useMutation } from "@apollo/client/react";
import {
  DeliverSelfAssessment,
  DeliverSelfAssessmentVariables,
} from "__generated__/types";
import { Button } from "common/buttons";
import { MutationLoadingOrError } from "common/components/forms/MutationLoadingOrError";
import { urls } from "common/urls";
import { useElements } from "domain/pages/ElementPage";
import gql from "graphql-tag";
import React from "react";
import { useNavigate } from "react-router";

const MUTATION = gql`
  mutation DeliverSelfAssessment($input: DeliverSelfAssessmentInput!) {
    deliverSelfAssessment(input: $input) {
      selfAssessment {
        id
        delivery {
          score {
            factorPercent
          }
          deliveredAt
        }
      }
    }
  }
`;

interface Props {
  selfAssessmentId?: string;
}

export const SelfAssessmentDelivery: React.FC<
  React.PropsWithChildren<Props>
> = ({ selfAssessmentId }) => {
  const { selfAssessmentId: selfAssessmentInstanceId } = useElements();

  const id = selfAssessmentInstanceId ?? selfAssessmentId;

  const navigate = useNavigate();

  const [
    deliverSelfAssessment,
    { error: mutationError, loading: mutationLoading },
  ] = useMutation<DeliverSelfAssessment, DeliverSelfAssessmentVariables>(
    MUTATION,
  );

  const handleDeliverSelfAssessment = async () => {
    if (id) {
      const result = await deliverSelfAssessment({
        variables: {
          input: {
            selfAssessmentId: id,
          },
        },
      });

      if (result.data) {
        navigate(urls.selfAssessment(id));
      }
    } else {
      console.log("missing instance id for selfassessment"); // TODO: Handle missing instanceId
    }
  };

  return (
    <>
      <Button loading={mutationLoading} onClick={handleDeliverSelfAssessment}>
        Sjekk ditt resultat
      </Button>
      <MutationLoadingOrError loading={false} error={mutationError} />
    </>
  );
};
